import NestedComponent from "./NestedComponent";

export default NestedComponent;
